import H5Orientation from 'h5-orientation';

export default H5Orientation;
